import React, { Component } from 'react';
import styleable from 'react-styleable';
import '../../styles/core.scss';
import { connect } from 'react-redux';
import css from './booking-fee-disclaimer-link.scss';
import DetailsModal from '../details-modal/details-modal';
import { bindActionCreators } from 'redux';
import { fetchPost } from '../helpers/common-actions';
import cookie from 'react-cookie';
import BookingFeeDisclaimer from './booking-fee-disclaimer';
import { loadModalContent } from '../details-modal/details-modal-actions';
import { BOOKING_FEE_DISCLAIMER_FETCHED } from './booking-fee-disclaimer-actions';
import { Cookie } from '../../constants/settings';

@styleable(css)
class BookingFeeDisclaimerLink extends Component {
  static propTypes = {
    css: React.PropTypes.object,
    data: React.PropTypes.object,
    fetchPost: React.PropTypes.func,
    loadModalContent: React.PropTypes.func,
    route: React.PropTypes.object,
    bookingFeeDisclaimerReducer: React.PropTypes.array
  };

  constructor() {
    super();
    this.bookingFeeCta = this.bookingFeeCta.bind(this);
    this.state = {
      data: {
        protocol: null,
        host: null,
        agentId: null
      },
      bookingFeeDisclaimerApiUrl: 'booking/api/search/getBookingFeeAllRules',
      micrositeCookie: cookie.load(Cookie.MICROSITE_COOKIE),
      showDisclaimerLink: true
    };
  }

  componentWillMount() {
    this.fetchBookingFee();
  }

  fetchBookingFee() {
    const { options } = this.props;
    const agentId = options.agentId;

    this.state.data.domain = options.domainUrl;
    this.state.data.agentId = agentId;

    const baseURL = options.baseURL ? options.baseURL : `${window.location.protocol}//${window.location.hostname}/`;

    this.props.fetchPost({
      dataUrl: `${baseURL}${this.state.bookingFeeDisclaimerApiUrl}`,
      data: this.state.data,
      dataAcquiredType: BOOKING_FEE_DISCLAIMER_FETCHED,
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      successCallBack: this.success,
      failCallBack: () => {}
    });
  }

  success = () => {};

  bookingFeeCta() {
    const { options } = this.props;
    const micrositeCookie = this.state.micrositeCookie;
    const agentId = options.agentId != null ? options.agentId : (micrositeCookie ? micrositeCookie.agentId : null);

    this.props.loadModalContent({
      height: '80%',
      overlayClicked: true,
      headerFooter: 'show',
      component: (<BookingFeeDisclaimer
        agentId={agentId}
        domain={options.baseUrl}
        baseURL={options.baseUrl}
      />),
      vis: true
    });
  }

  render() {
    const { bookingFeeDisclaimerReducer } = this.props;

    return (
      <span>
        <DetailsModal />
        {bookingFeeDisclaimerReducer !== null &&
        bookingFeeDisclaimerReducer !== undefined ? (
          bookingFeeDisclaimerReducer.length !== 0 ? (
            <div
              className={css['view-link']}
              onClick={() => this.bookingFeeCta()}
            >
              <span className={css['link-text']}>Booking Fees Apply</span>
            </div>
          ) : (
            ''
          )
        ) : (
          ''
        )}
      </span>
    );
  }
}

function mapStateToProps(state) {
	return {
    bookingFeeDisclaimerReducer: state.bookingFeeDisclaimerReducer
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
    loadModalContent,
    fetchPost
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(BookingFeeDisclaimerLink);
